// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-page_PlayerPage__nifB3{
    width: 100%;
    overflow: auto;
    align-items: center;
}
.news-page_ContentContainer__8WV6v{
    min-width: min-content;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
}
.news-page_FormContainer__-1SGf {
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    justify-content: start;
}
.news-page_ControlPanel__cPLdN{
    width: 100%;
    display: flex;
    justify-content: start;
}
.news-page_ControlPanel__cPLdN > *{
    margin-left: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/NewsPage/ui/news-page.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;AACrB","sourcesContent":[".PlayerPage{\n    width: 100%;\n    overflow: auto;\n    align-items: center;\n}\n.ContentContainer{\n    min-width: min-content;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n}\n.FormContainer {\n    max-width: 1200px;\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n}\n.ControlPanel{\n    width: 100%;\n    display: flex;\n    justify-content: start;\n}\n.ControlPanel > *{\n    margin-left: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"PlayerPage": `news-page_PlayerPage__nifB3`,
	"ContentContainer": `news-page_ContentContainer__8WV6v`,
	"FormContainer": `news-page_FormContainer__-1SGf`,
	"ControlPanel": `news-page_ControlPanel__cPLdN`
};
export default ___CSS_LOADER_EXPORT___;
